import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/buromobelexperte': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 32h128v128h-128v-128zM120 152v-112h-112v112h112zM160 32h128v128h-128v-128zM280 152v-112h-112v112h112zM320 32h128v128h-128v-128zM440 152v-112h-112v112h112zM0 192h128v128h-128v-128zM120 312v-112h-112v112h112zM160 192h128v128h-128v-128zM280 312v-112h-112v112h112zM320 192h128v128h-128v-128zM440 312v-112h-112v112h112zM0 352h128v128h-128v-128zM120 472v-112h-112v112h112zM160 352h128v128h-128v-128zM280 472v-112h-112v112h112zM320 352h128v128h-128v-128z'
      }
    ]
  }
})
